export default "__VITE_ASSET__0Yd82Lmr__"